<div appFont
     class="empty-state"
     [hierarchy]="types.FontHierarchy.Primary"
     [type]="types.FontType.Bold">
  <ng-content></ng-content>
</div>
